import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {when} from 'lit/directives/when.js';
import {router, navigator} from 'lit-element-router';

import store from '../../store';
import style from '../../../../scss/login.scss';
import {authenticateWithToken} from '../../slices/accountSlice';
import getRoutes from '../../routes';
import {navigateTo} from '../../slices/statusSlice';
import {getTenantData} from '../../../tenants';
import {selectTenant} from '../../selectors';
import arrowRight from '../../icons/arrowRight';

@customElement('arc-login')
export class Login extends connect(store)(router(navigator(LitElement))) {
	static styles = [style];

	static properties = {
		loginToken: {type: String},
		loginEmail: {type: String},
		consent: {type: Boolean},
		loginSession: {type: Boolean}
	};

	devLoginToken = null;

	constructor() {
		super();
		this.loginToken = '';
		this.loginEmail = '';
		this.consent = false;
		this.longSession = false;
		store.subscribe(() => this.requestUpdate());
	}

	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.route = route;
		this.params = params;
		this.query = query;
	}

	stateChanged(state) {
		this.accountData = state.account.data.account;
		this.tenant = selectTenant(state);
		this.accountStatus = state.account.status;
		this.loggedIn = state.account.data.loggedIn;
		this.account = state.account.data.account;
		if (state.account.data.loginEmail && this.loginEmail === '') {
			this.loginEmail = state.account.data.loginEmail;
		}
		this.loggedIn = state.account.data.loggedIn;
		this.inputErrors = state.account.data.errors?.input?.params;
	}

	async connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	// handle Inputs
	onEmailInput(input) {
		this.loginEmail = input;
	}
	onLoginTokenInput(input) {
		this.loginToken = input;
	}
	onConsent(checked) {
		this.consent = checked === 1;
	}
	onLongSession(checked) {
		this.longSession = checked === 1;
	}
	onRequestCode() {
		store.dispatch(navigateTo({route: 'home', params: this.params}));
	}
	isLoginPossible() {
		return this.loginEmail !== '' && this.loginToken !== '' && this.consent;
	}

	onAuthenticate(input) {
		store.dispatch(
			authenticateWithToken({
				email: this.loginEmail,
				token: this.loginToken,
				consent: this.consent,
				longSession: this.longSession,
			})
		);
	}

	render(e) {
		const state = store.getState();

		return html`
			<arc-welcome>
				${when(
					this.loggedIn,
					() => html`
						<p>
							${msg('login message')}
						</p>
					`,
					() => html`
						<div class="login">
							<h1 class="title">
								${msg('Login')}
							</h1>
							<p>
								${msg('login_description')}
							</p>
							<div class="form">
								<arc-text-input
									title="${msg('Email')}"
									required="true"
									placeholder="${msg('Enter Email')}"
									.value=${this.loginEmail}
									.errors=${this.inputErrors?.email?.errors}
									@value-change=${(ev) => this.onEmailInput(ev.detail.value)}>
								</arc-text-input>
								<arc-text-input
									title="${msg('Token')}"
									required="true"
									placeholder="${msg('Enter Token')}"
									.value=${this.loginToken}
									.errors=${this.inputErrors?.loginToken?.errors}
									@value-change=${(ev) => this.onLoginTokenInput(ev.detail.value)}>
								</arc-text-input>
							</div>
							<arc-checkbox
								title="${msg('I do consent to the')}<a href='${getTenantData(this.tenant, 'privacyUrl')}'>${msg('privacy policy')}</a>."
								required="true"
								.noFieldTitle=${true}
								.value=${this.consent}
								.errors=${this.inputErrors?.consent?.errors}
								@value-change=${(ev) => this.onConsent(ev.detail.value)}>
							</arc-checkbox>
							<arc-checkbox
								title="${msg('LongSession')}"
								.noFieldTitle=${true}
								.value=${this.longSession}
								.errors=${this.inputErrors?.longSession?.errors}
								@value-change=${(ev) => this.onLongSession(ev.detail.value)}>
							</arc-checkbox>

							<arc-button
								@click=${this.onAuthenticate}
								.disabled=${!this.isLoginPossible()}
								title="${msg('Log In')}"
								type="primary"
								showIcon="true"
								iconColor="ok"
								.additionalInfo="${false}">
								${arrowRight}
							</arc-button>

							<arc-button
								@click=${this.onRequestCode}
								title="${msg('Request code again')}"
								type="secondary"
								.additionalInfo="${false}">
							</arc-button>
						</div>
					`
				)}
			</arc-welcome>
		`;
	}
}
